const managePageWeb = [
  {
    path: '/collections-web',
    name: 'collections-web',
    component: () => import('@/views/collections/IndexWebPage.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_manage_site_builder',
      resource: 'all',
    },
  },
  {
    path: '/collection/banner/create/:platform/:page',
    name: 'create-banner-collection',
    component: () => import('@/views/collections/banner/CreateBannerCollectionPage.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_manage_site_builder',
      resource: 'all',
    },
  },
  {
    path: '/collection/banner/edit/:platform/:page/:id',
    name: 'edit-banner-collection',
    component: () => import('@/views/collections/banner/CreateBannerCollectionPage.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_manage_site_builder',
      resource: 'all',
    },
  },
  {
    path: '/collection/product/create',
    name: 'create-product-collection',
    component: () => import('@/views/collections/product/ProductCollectionPage.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_manage_site_builder',
      resource: 'all',
    },
  },
  {
    path: '/collection/product/edit/:platform/:id',
    name: 'edit-product-collection',
    component: () => import('@/views/collections/product/ProductCollectionPage.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_manage_site_builder',
      resource: 'all',
    },
  },
  {
    path: '/collection/slider/create/:platform/:page',
    name: 'create-slider-collection',
    component: () => import('@/views/collections/slider/CreateSliderCollection.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_manage_site_builder',
      resource: 'all',
    },
  },
  {
    path: '/collection/slider/edit/:platform/:page/:id',
    name: 'edit-slider-collection',
    component: () => import('@/views/collections/slider/CreateSliderCollection.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_manage_site_builder',
      resource: 'all',
    },
  },
  {
    path: '/collections-mobile',
    name: 'collections-mobile',
    component: () => import('@/views/collections/IndexMobile.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_tickets_template',
      resource: 'all',
    },
  },
]

export default managePageWeb
